// export function setToken(token) {
//     localStorage.setItem('access-token', token)
// }

// export function getToken() {
//     return localStorage.getItem('access-token')
// }

// export function clearToken() {
//     localStorage.removeItem('access-token')
// }

import Cookies from 'js-cookie'
import jwt from 'jsonwebtoken'

const BSRS_ACCESS_TOKEN = 'bsrs_access_token'
const ACCESS_TOKEN = 'access_token'
const EXPIRES_ON = 'expires_on'
const REFRESH_TOKEN = 'refresh_token'
const SERVICE_TOKEN = 'service_token'
const ROOM = 'room'
const API_URL = 'api_server_url'
const CLIENT_ID = 'client_id'
const SERVICE_TOKEN_EXPIRES = 'service_token_expires_on'
const IS_INTEGRATION = 'isIntegration'
const USER_ID = 'id'
const LIMIT_USERS = 'limitUser'
const FIRST_NAME = 'firstName'
const EMAIL = 'email'
const IS_USER_AD = 'isUserActiveDirectory'
const SYSTEM = 'system'
const COMPANY_CODE = 'companyCode'

export function getCookie(key) {
    return Cookies.get(key)
}

export function setCookie(key, value) {
    Cookies.set(key, value)
}

export function removeCookie(key) {
    Cookies.remove(key)
}

export function getAccessToken() {
    return getCookie(ACCESS_TOKEN)
}

export function getRoom() {
    return getCookie(ROOM)
}

export function getService() {
    return getCookie({ CLIENT_ID, API_URL })
}

export function getAllToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {}
    return {
        access_token: getCookie(ACCESS_TOKEN),
        expires_on: getCookie(EXPIRES_ON),
        refresh_token: getCookie(REFRESH_TOKEN)
    }
}

export function setToken({
    access_token,
    expires_on,
    refresh_token
}) {
    setCookie(ACCESS_TOKEN, access_token)
    setCookie(EXPIRES_ON, expires_on)
    setCookie(REFRESH_TOKEN, refresh_token)
}

export function clearToken() {
    removeCookie(ACCESS_TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(REFRESH_TOKEN)
    removeCookie(SERVICE_TOKEN)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(ROOM)
    removeCookie(USER_ID)
    removeCookie(IS_INTEGRATION)
}

export function getServiceToken() {
    if (!getCookie(BSRS_ACCESS_TOKEN)) return {}
    return {
        service_token: getCookie(SERVICE_TOKEN),
        service_expires_on: getCookie(SERVICE_TOKEN_EXPIRES),
        user_id: getCookie(USER_ID),
        bsrsToken: getCookie(BSRS_ACCESS_TOKEN),
        isIntegration: getCookie(IS_INTEGRATION)
    }
}

export function getIsUserActiveDirectory() {
    return getCookie(IS_USER_AD)
}

export function setServiceToken({
    token,
    expires_on
}) {
    if (typeof (token) !== undefined)
        setCookie(SERVICE_TOKEN, token)
    if (typeof (expires_on) !== undefined)
        setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
}

export function getUserInfo(access_token) {
    if (!access_token) return {}

    const {
        iat,
        exp,
        appid,
        name,
        unique_name: email
    } = jwt.decode(access_token)

    return {
        iat,
        exp,
        appid,
        name,
        email
    }
}

export function getBSRSToken() {
    return getCookie(BSRS_ACCESS_TOKEN)
}

export function setBSRSToken(bsrsToken) {
    const { isIntegration, /*access_token, expires_on,*/ token, id, company, firstName, email, isUserActiveDirectory, system_key, companyCode } = bsrsToken
    let limitUser = 0
    if (company) limitUser = company.limitUser
    setCookie(BSRS_ACCESS_TOKEN, token)
    // setCookie(SERVICE_TOKEN, access_token)
    // setCookie(SERVICE_TOKEN_EXPIRES, expires_on)
    setCookie(IS_INTEGRATION, isIntegration)
    setCookie(USER_ID, id)
    setCookie(LIMIT_USERS, limitUser)
    setCookie(FIRST_NAME, firstName)
    setCookie(EMAIL, email)
    setCookie(IS_USER_AD, isUserActiveDirectory)
    setCookie(SYSTEM, system_key)
    setCookie(COMPANY_CODE, companyCode)
}

export function getLimitUser() {
    return (getCookie(LIMIT_USERS))
}

export function getSystem() {
    return (getCookie(SYSTEM))
}

export function getCompanyCode() {
    return getCookie(COMPANY_CODE)
}

export function getUserFirstName() {
    return (getCookie(FIRST_NAME))
}

export function setRoomToken(room, client_id, api_server_url) {
    setCookie(ROOM, room)
    setCookie(CLIENT_ID, client_id)
    setCookie(API_URL, api_server_url)
}

export function clearBSRSToken() {
    removeCookie(BSRS_ACCESS_TOKEN)
    removeCookie(SERVICE_TOKEN)
    removeCookie(SERVICE_TOKEN_EXPIRES)
    removeCookie(USER_ID)
    removeCookie(IS_INTEGRATION)
    removeCookie(LIMIT_USERS)
    removeCookie(FIRST_NAME)
    removeCookie(EMAIL)
    removeCookie(IS_USER_AD)
    removeCookie(SYSTEM)
    removeCookie(COMPANY_CODE)
}

export function getResultPerPage() {
    return 10
}


// WEBPACK FOOTER //
// ./src/lib/auth.js